'use strict';

function FormAppSubmitGroupObjectService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/form-groups/:groupId/publications');
}

angular.module('dokiv')
  .factory('FormAppSubmitGroupObjectService', ['$resource', 'config', FormAppSubmitGroupObjectService]);




//////////////////
// WEBPACK FOOTER
// ./scripts/company/form-app-submit-group/FormAppSubmitGroupObjectService.js
// module id = 353
// module chunks = 0